import { Button } from "@workspace/frontend-ui";
import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import useTranslations from "../../i18n/useTranslations";
import type { Tier } from "../../types";
import getTierLevel from "./getTierLevel";
import TierRung from "./TierRung";

type Props = {
  tier: Tier;
};

const TierLevels: FC<Props> = ({ tier }) => {
  const {
    state: { currentPoints },
    send,
  } = useRewardCenter();
  const t = useTranslations();
  const { milestones, reached } = getTierLevel(tier, currentPoints);

  return (
    <div data-slot="tier-levels" className="flex flex-col gap-3 pt-3">
      <div className="h-px bg-foreground/15" />
      <div className="flex justify-between font-semibold text-xs opacity-70">
        <span>{t("reward_center.tier.levels")}</span>
        <span>{tier.name}</span>
      </div>
      <div className="rc-scroll-none flex max-h-48.5 flex-col gap-1 overflow-y-auto">
        {milestones.map((milestone, index) => (
          <TierRung
            key={milestone.id}
            milestone={milestone}
            done={index < reached}
            color={tier.badgeLight}
          />
        ))}
      </div>
      <div className="h-px bg-foreground/15" />
      <Button
        variant="unstyled"
        size="sm"
        className="h-8 w-full rounded-lg bg-foreground/10 font-semibold text-xs hover:bg-foreground/15"
        onClick={() => send("rewardCenter", { type: "selectTab", tab: "faq" })}
      >
        {t("reward_center.tier.read_more")}
      </Button>
      <p className="text-center text-xs opacity-60">
        {t("reward_center.tier.levels_description")}
      </p>
    </div>
  );
};

export default TierLevels;
